// src/pages/Relatorios/RelatorioFaturamento.jsx
import React, { useState } from 'react';
import { Button, Breadcrumb } from 'antd';
import RelatorioFaturamentoContent from './RelatorioFaturamentoContent';
import RelatorioVendas from './RelatorioVendas';
import RelatorioProdutos from './RelatorioProdutos';
import RelatorioClientes from './RelatorioClientes';
import RelatorioPagamentos from './RelatorioPagamentos';

const RelatorioFaturamento = () => {
  const [selectedKey, setSelectedKey] = useState('faturamento');

  const renderRelatorio = () => {
    switch (selectedKey) {
      case 'faturamento':
        return <RelatorioFaturamentoContent />;
      case 'vendas':
        return <RelatorioVendas />;
      case 'produtos':
        return <RelatorioProdutos />;
      case 'clientes':
        return <RelatorioClientes />;
      case 'pagamentos':
        return <RelatorioPagamentos />;
      default:
        return <RelatorioFaturamentoContent />;
    }
  };

  return (
    <div className="content-wrapper">
    <h3>Relatórios</h3>
      {/* Breadcrumb */}
      <Breadcrumb style={{ marginBottom: 16 }}>
        <Breadcrumb.Item>Relatórios</Breadcrumb.Item>
        <Breadcrumb.Item>
          {selectedKey.charAt(0).toUpperCase() + selectedKey.slice(1)}
        </Breadcrumb.Item>
      </Breadcrumb>

      {/* Botões de navegação */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        <Button
          type={selectedKey === 'faturamento' ? 'primary' : 'default'}
          onClick={() => setSelectedKey('faturamento')}
        >
          Faturamento
        </Button>
        <Button
          type={selectedKey === 'vendas' ? 'primary' : 'default'}
          onClick={() => setSelectedKey('vendas')}
        >
          Vendas
        </Button>
        <Button
          type={selectedKey === 'produtos' ? 'primary' : 'default'}
          onClick={() => setSelectedKey('produtos')}
        >
          Produtos
        </Button>
        <Button
          type={selectedKey === 'clientes' ? 'primary' : 'default'}
          onClick={() => setSelectedKey('clientes')}
        >
          Clientes
        </Button>
        <Button
          type={selectedKey === 'pagamentos' ? 'primary' : 'default'}
          onClick={() => setSelectedKey('pagamentos')}
        >
          Pagamentos
        </Button>
      </div>

      {/* Conteúdo do Relatório */}
      <div>
        {renderRelatorio()}
      </div>
    </div>
  );
};

export default RelatorioFaturamento;
